import React, { useEffect, useRef } from 'react';
import { Flex, Text, Button, Link, Image } from 'rebass/styled-components';
import logo from '../../assets/images/aisle-mgmt-logo.png';

const SignUpThanks = () => {
  let buttonRef = useRef();

  useEffect(() => {
    buttonRef.current.focus();
  }, []);

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      py={14}
      px={[4, 15, 16]}
    >
      <Flex justifyContent="center" pb={10}>
        <Image src={logo} alt="aiSLE MGMT"></Image>
      </Flex>
      <Text fontSize={['20px', '24px']} textAlign="center">
        <strong>
          Thank you! Your aiSLE MGMT Welcome Kit request has been received
        </strong>
      </Text>
      <Text fontSize={['16px', '20px']} textAlign="center" py={5} color="grey2">
        Click below to learn more about the technologies included in aiSLE MGMT
      </Text>
      <Flex justifyContent="center">
        <Link
          href="https://lupuscorner.com/new-lab-test-identifies-lupus-flare-risk-12-weeks-in-advance/"
          target="_blank"
        >
          <Button
            ref={buttonRef}
            variant="main"
            fontSize={[4, 6]}
          >
            learn more
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
};

export default SignUpThanks;
